import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { Field } from 'redux-form';

import TemplatesCreateEditFormAside from './TemplatesCreateEditFormAside';
import TemplatesCreateEditFormEmpty from './TemplatesCreateEditFormEmpty';
import TemplatesCreateEditFormField from './TemplatesCreateEditFormField';

const styles = () => ({
  root: {
    position: 'relative',
  },
  main: {
    position: 'relative',
    boxSizing: 'border-box',
    height: '100%',
    padding: '16px 16px 80px 16px',
  },
});

class TemplatesCreateEditFormBody extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropActive: false,
      offsetFields: [],
      draggableData: {},
      dragged: false,
      timestamp: Date.parse(new Date()),
    };

    this.onAsideItemStartDrag = this.onAsideItemStartDrag.bind(this);
    this.onAsideItemDrag = this.onAsideItemDrag.bind(this);
    this.onAsideItemStopDrag = this.onAsideItemStopDrag.bind(this);
    this.onFieldDragStart = this.onFieldDragStart.bind(this);
    this.onFieldDrag = this.onFieldDrag.bind(this);
    this.onFieldDragStop = this.onFieldDragStop.bind(this);
    this.onDraggableDataChange = this.onDraggableDataChange.bind(this);
    this.onFieldGridWidthSwitch = this.onFieldGridWidthSwitch.bind(this);
  }

  onDraggableDataChange(data) {
    this.setState({
      draggableData: {
        ...this.state.draggableData,
        ...data,
      },
    });
  }

  onAsideItemStartDrag() {
    this.setState({ dragged: true });
  }

  onAsideItemDrag(data) {
    const { fields } = this.props;
    const { draggableData } = this.state;
    let dropActive;
    if (data.x + (data.width * 0.8) > this.mainRef.offsetLeft) {
      dropActive = true;
    } else {
      dropActive = false;
    }
    const offsetFields = fields.reduce((accumulator, field, index) => {
      if (draggableData[field] !== undefined
        && ((draggableData[field].height / 2) - draggableData[field].bounds.top)
        > data.y) {
        return [
          ...accumulator,
          {
            fieldIndex: index,
            offsetY: data.height + 16,
          },
        ];
      }
      return accumulator;
    }, []);
    if (data.x + (data.width * 0.8) > this.mainRef.offsetLeft) {
      dropActive = true;
    } else {
      dropActive = false;
    }

    this.setState({
      offsetFields,
      dropActive,
    });
  }

  onAsideItemStopDrag(data) {
    const { fields } = this.props;
    const { dropActive, offsetFields } = this.state;
    const newValue = {
      'Question Type': data.variant,
      ...['Radio', 'Checkbox', 'DropDown'].indexOf(data.variant) !== -1
        ? { Choices: ['Option 1'] } : {},
      ...['Textbox', 'MultiLine', 'Radio', 'Checkbox', 'DropDown', 'Date']
        .indexOf(data.variant) !== -1
        ? { Text: 'Subject line' } : {},
      ...data.variant === 'Signature'
        ? { Text: 'Content' } : {},
      'Grid Width': 12,
    };
    const moveIndex = offsetFields.length > 0 ? offsetFields[0].fieldIndex : -1;
    if (dropActive) {
      if (moveIndex === -1) {
        fields.push(newValue);
      } else {
        fields.insert(moveIndex, newValue);
      }
      this.setState({ timestamp: Date.parse(new Date()) });
    }
    this.setState({
      dragged: false,
      dropActive: false,
      offsetFields: [],
    });
  }

  onFieldDragStart() {
    this.setState({ dragged: true });
  }

  onFieldDrag(data) {
    const { fields } = this.props;
    const { draggableData } = this.state;
    const moveGridWidth = fields.get(data.index)['Grid Width'];
    let moveDirectionY;
    let moveDirectionX;
    if (Math.abs(data.defaultY - data.y) > 20) {
      moveDirectionY = data.y > data.defaultY ? 'bottom' : 'top';
    }
    if (Math.abs(data.defaultX - data.x) > 20) {
      moveDirectionX = data.x > data.defaultX ? 'right' : 'left';
    }
    const offsetFields = fields.reduce((accumulator, field, index) => {
      if (index === data.index) {
        return accumulator;
      }
      if (moveGridWidth === 12) {
        if (moveDirectionY === 'bottom') {
          if (index > data.index
            && draggableData[field] !== undefined
            && ((draggableData[field].height / 2) - draggableData[field].bounds.top)
            < (data.y + data.height)) {
            return [
              ...accumulator,
              {
                fieldIndex: index,
                offsetY: -data.height,
              },
            ];
          }
          return accumulator;
        }
        if (moveDirectionY === 'top') {
          if (index < data.index
            && draggableData[field] !== undefined
            && ((draggableData[field].height / 2) - draggableData[field].bounds.top)
            > data.y) {
            return [
              ...accumulator,
              {
                fieldIndex: index,
                offsetY: data.height,
              },
            ];
          }
          return accumulator;
        }
        return accumulator;
      }
      if (moveGridWidth === 6) {
        if (moveDirectionX === 'right') {
          if (draggableData[field] !== undefined
            && index === data.index + 1
            && fields.get(index)['Grid Width'] === 6
            && ((draggableData[field].width / 2) - draggableData[field].bounds.left)
            < (data.x + data.width)) {
            return [
              ...accumulator,
              {
                fieldIndex: index,
                offsetX: -data.width,
              },
            ];
          }
          return accumulator;
        }
        if (moveDirectionX === 'left') {
          if (draggableData[field] !== undefined
            && index === data.index - 1
            && ((draggableData[field].width / 2) - draggableData[field].bounds.left)
            > data.x) {
            return [
              ...accumulator,
              {
                fieldIndex: index,
                offsetX: data.width,
              },
            ];
          }
          return accumulator;
        }
        if (moveDirectionY === 'top') {
          if (index < data.index
            && fields.get(index)['Grid Width'] === 6
            && fields.map((item, fieldIndex) => fields.get(fieldIndex)['Grid Width'])
              .slice(index, data.index).indexOf(12) === -1
            && draggableData[field] !== undefined
            && draggableData[field].bounds.left === -data.defaultX
            && ((draggableData[field].height / 2) - draggableData[field].bounds.top)
            > data.y) {
            return [
              ...accumulator,
              {
                fieldIndex: index,
                offsetY: data.height,
              },
            ];
          }
          return accumulator;
        }
        if (moveDirectionY === 'bottom') {
          if (index > data.index
            && fields.get(index)['Grid Width'] === 6
            && fields.map((item, fieldIndex) => fields.get(fieldIndex)['Grid Width'])
              .slice(data.index, index).indexOf(12) === -1
            && draggableData[field] !== undefined
            && draggableData[field].bounds.left === -data.defaultX
            && ((draggableData[field].height / 2) - draggableData[field].bounds.top)
            < (data.y + data.height)) {
            return [
              ...accumulator,
              {
                fieldIndex: index,
                offsetY: -data.height,
              },
            ];
          }
          return accumulator;
        }
        return accumulator;
      }
      return accumulator;
    }, []);
    this.setState({ offsetFields });
  }

  onFieldDragStop(data) {
    const { fields } = this.props;
    const { offsetFields } = this.state;
    if (offsetFields.length > 0) {
      const moveGridWidth = fields.get(data.index)['Grid Width'];
      let moveDirectionY;
      let moveDirectionX;
      let moveIndex;
      if (Math.abs(data.defaultY - data.y) > 20) {
        moveDirectionY = data.y > data.defaultY ? 'bottom' : 'top';
      }
      if (Math.abs(data.defaultX - data.x) > 20) {
        moveDirectionX = data.x > data.defaultX ? 'right' : 'left';
      }
      this.setState({
        dragged: false,
        offsetFields: [],
      });
      if (moveDirectionY === 'top' || moveDirectionX === 'left') {
        moveIndex = offsetFields[0].fieldIndex;
      }
      if (moveDirectionY === 'bottom' || moveDirectionX === 'right') {
        moveIndex = offsetFields[offsetFields.length - 1].fieldIndex;
      }
      if (moveIndex !== undefined) {
        if (moveGridWidth === 6) {
          fields.swap(data.index, moveIndex);
        }
        if (moveGridWidth === 12) {
          fields.move(data.index, moveIndex);
        }
        this.setState({ timestamp: Date.parse(new Date()) });
      }
    }
  }

  onFieldGridWidthSwitch() {
    this.setState({ timestamp: Date.parse(new Date()) });
  }

  render() {
    const {
      fields,
      classes,
    } = this.props;
    const { offsetFields, dragged, dropActive, timestamp } = this.state;
    return (
      <Paper className={classes.root}>
        <Grid
          container
          spacing={0}
        >
          <Grid item xs={4}>
            <TemplatesCreateEditFormAside
              boundsSelector={`.${classes.root}`}
              onItemStartDrag={this.onAsideItemStartDrag}
              onItemDrag={this.onAsideItemDrag}
              onItemStopDrag={this.onAsideItemStopDrag}
            />
          </Grid>
          <Grid item xs={8}>
            <div
              ref={(mainRef) => {
                this.mainRef = mainRef;
              }}
              className={classes.main}
            >
              {fields.length > 0 ? (
                <Grid
                  container
                  spacing={0}
                >
                  {fields.map((field, index) => {
                    const offsetFieldIndex = offsetFields
                      .findIndex(item => (item.fieldIndex === index));
                    return (
                      <Field
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        index={index}
                        name={field}
                        component={TemplatesCreateEditFormField}
                        onRemove={() => fields.remove(index)}
                        onStartDrag={this.onFieldDragStart}
                        onDrag={this.onFieldDrag}
                        onStopDrag={this.onFieldDragStop}
                        boundsSelector={`.${classes.main}`}
                        withTransition={dragged}
                        timestamp={timestamp}
                        onDraggableDataChange={this.onDraggableDataChange}
                        onGridWidthSwitch={this.onFieldGridWidthSwitch}
                        {...offsetFieldIndex !== -1
                          ? {
                            offsetY: offsetFields[offsetFieldIndex].offsetY,
                            offsetX: offsetFields[offsetFieldIndex].offsetX,
                          } : {}}
                      />
                    );
                  })}
                </Grid>
              ) : (
                <TemplatesCreateEditFormEmpty dropActive={dropActive} />
              )}
            </div>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

TemplatesCreateEditFormBody.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string,
    move: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    main: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(TemplatesCreateEditFormBody);



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesCreateEditForm/TemplatesCreateEditFormBody.js